<template>
  <div>
    <b-card v-if="editAccount">
      <b-tabs pills card>
        <b-tab :title="$t('Main')" active>
          <b-form-group label-align="right" :label="$t('Account ID')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-form-input type="number" v-model="editAccount.account_id" disabled/>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('Credit')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-form-input type="number" v-model="editAccount.credit" />
          </b-form-group>
          <b-form-group label-align="right" :label="$t('Balance')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-form-input type="number" v-model="editAccount.balance" disabled/>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('VAT')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-form-input type="number" v-model="editAccount.vat_rate" />
          </b-form-group>
          <b-form-group label-align="right" :label="$t('External ID')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-form-input type="text" v-model="editAccount.external_id" />
          </b-form-group>
          <b-form-group label-align="right" :label="$t('Sale tax rate')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-form-input type="number" v-model="editAccount.sale_tax_rate" />
          </b-form-group>
        </b-tab>
        <b-tab :title="$t('IPTV settings')">
          <b-form-group label-align="right" :label="$t('Irdeto IPTV access card')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-form-input type="text" v-model="editAccount.irdeto_access_card_number"/>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('Queries irdeto IPTV access card')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-input-group>
              <b-form-select type="number" v-model="curQuerie" :options="optionsQueries"/>
              <b-input-group-append>
                <b-button variant="info" size="sm" @click="querieIrdetoCard">{{ $t('Create') }}</b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('Irdeto IPTV STB')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-form-input type="text" v-model="editAccount.irdeto_stb_serial_number"/>
          </b-form-group>
        </b-tab>
        <b-tab :title="$t('State settings')">
          <b-form-group label-align="right" :label="$t('Unlimited mode')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-form-checkbox v-model="editAccount.unlimited"/>
          </b-form-group>
          <b-form-group label-align="right" id="currenciesInputGroup" :label="$t('Internet')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-form-select id="blocks" :options="internet" required v-model="editAccount.int_status"/>
            <b-form-checkbox v-model="editAccount.auto_enable_inet">{{ $t('Auto enable internet') }}</b-form-checkbox>
          </b-form-group>
          <b-form-group label-align="right" id="currenciesInputGroup" :label="$t('Block')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-form-select id="blocks" :options="blocks_to_show" required v-model="editAccount.block_type"/>
          </b-form-group>
          <b-row v-if="editAccount.block_type != 0">
            <b-col>
              <b-form-group label-cols-sm="1">
                <b-form-input type=date v-model="editAccount.block_start"/>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group label-cols-sm="1">
                <b-form-input type=date v-model="editAccount.block_end"/>
              </b-form-group>
            </b-col>
          </b-row>
        </b-tab>
      </b-tabs>
      <b-row>
        <b-col>
          <b-button type="submit" variant="success" stoptionsQueriesyle="float: right; width: 120px" @click="save()">{{ $t('Save') }}</b-button>
        </b-col>
        <b-col sm="2.5">
          <b-button variant="secondary" style="float: right ;width: 120px" @click="close()">{{ $t('Cancel') }}</b-button>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import axiosInstance from '@/utils/api.js'
import moment from 'moment'

export default {
  props: {
    accountInfo: null,
    currentRow: null
  },
  data () {
    return {
      curQuerie: 1,
      IPTVcard: {
        'account_id': 0,
        'access_card_number': 0
      },
      editAccessCardNumber: 0,
      editAccount: null,
      internet: [{'text': this.$i18n.t('On'), 'value': 1}, {'text': this.$i18n.t('Off'), 'value': 0}],
      blocks_to_show: [{'text': this.$i18n.t('Active'), 'value': 0}, {'text': this.$i18n.t('Admin block'), 'value': 256}],
      block_user: {'text': this.$i18n.t('User block'), 'value': 1},
      block_system: {'text': this.$i18n.t('System block'), 'value': 16},
      optionsQueries: [
        {text: this.$i18n.t('Activate card'), value: 1},
        {text: this.$i18n.t('Deactivate card'), value: 2},
        {text: this.$i18n.t('Pair chipset'), value: 3},
        {text: this.$i18n.t('Unpair all chipsets'), value: 4},
        {text: this.$i18n.t('Reset PIN'), value: 5},
        {text: this.$i18n.t('Synchronize'), value: 6}
      ]
    }
  },
  mounted () {
    this.load()
  },
  watch: {
    currentRow: function (val) {
      this.load()
    }
  },
  methods: {
    async querieIrdetoCard () {
      switch (this.curQuerie) {
        case 1:
          await this.$store.dispatch('Users/GET_IRDETO_ACTIVATE', this.editAccount.irdeto_access_card_number).then(response => {
            if (this.$store.getters['Users/IRDETO_ACTIVATE'].length > 0) {
              this.$root.$emit('makeToasts')
            } else {
              this.$root.$emit('makeToasts', 'danger', 'LogicError: Failed to activate Irdeto CAS service', 'Error')
            }
          })
          break
        case 2:
          await this.$store.dispatch('Users/GET_IRDETO_DEACTIVATE', this.editAccount.irdeto_access_card_number).then(response => {
            if (this.$store.getters['Users/IRDETO_DEACTIVATE'].length > 0) {
              this.$root.$emit('makeToasts')
            } else {
              this.$root.$emit('makeToasts', 'danger', 'LogicError: Failed to deactivate Irdeto CAS service', 'Error')
            }
          })
          break
        case 3:
          await this.$store.dispatch('Users/GET_IRDETO_PAIR_CHIPSET', this.editAccount).then(response => {
            if (this.$store.getters['Users/IRDETO_PAIR_CHIPSET'].length > 0) {
              this.$root.$emit('makeToasts')
            } else {
              this.$root.$emit('makeToasts', 'danger', 'LogicError: Failed to pairChipSet Irdeto CAS service', 'Error')
            }
          })
          break
        case 4:
          await this.$store.dispatch('Users/GET_IRDETO_UNPAIR_ALL_CHIPSET', this.editAccount.irdeto_access_card_number).then(response => {
            if (this.$store.getters['Users/IRDETO_UNPAIR_ALL_CHIPSET'].length > 0) {
              this.$root.$emit('makeToasts')
            } else {
              this.$root.$emit('makeToasts', 'danger', 'LogicError: Failed to unpairChipSet Irdeto CAS service', 'Error')
            }
          })
          break
        case 5:
          await this.$store.dispatch('Users/GET_IRDETO_RESET_PIN', this.editAccount.irdeto_access_card_number).then(response => {
            if (this.$store.getters['Users/IRDETO_RESET_PIN'].length > 0) {
              this.$root.$emit('makeToasts')
            } else {
              this.$root.$emit('makeToasts', 'danger', 'LogicError: Failed to overwriteParentalPinCode Irdeto CAS service', 'Error')
            }
          })
          break
        case 6:
          await this.$store.dispatch('Users/GET_IRDETO_SYNCHRONIZE', this.editAccount.irdeto_access_card_number).then(response => {
            if (this.$store.getters['Users/IRDETO_SYNCHRONIZE'].length > 0) {
              this.$root.$emit('makeToasts')
            } else {
              this.$root.$emit('makeToasts', 'danger', 'LogicError: Failed to synchronize Irdeto CAS service', 'Error')
            }
          })
          break
      }
    },
    load () {
      if (this.accountInfo) {
        this.editAccount = this.accountInfo
      } else {
        this.editAccount = JSON.parse(JSON.stringify(this.currentRow))
      }
      this.editAccessCardNumber = JSON.parse(JSON.stringify(this.editAccount.access_card_number))
      switch (Number(this.editAccount.block_type)) {
        case 16 : {
          this.blocks_to_show.push(this.block_system)
          break
        }
        case 1 : {
          this.blocks_to_show.push(this.block_user)
          break
        }
      }
      this.editAccount.auto_enable_inet = (this.editAccount.flags === 8)
      if (this.editAccount.block_start && this.editAccount.block_end) {
        this.editAccount.block_start = moment(Number(this.editAccount.block_start) * 1000).format('YYYY-MM-DD')
        this.editAccount.block_end = moment(Number(this.editAccount.block_end) * 1000).format('YYYY-MM-DD')
      } else {
        this.editAccount.block_start = moment(this.editAccount.block_start).format('YYYY-MM-DD')
        this.editAccount.block_end = moment(this.editAccount.block_end).format('2033-05-18')
      }
    },
    close () {
      this.$emit('close', null)
    },
    save () {
      this.editAccount.block_start = this.editAccount.block_start ? Number(Date.parse(this.editAccount.block_start)) / 1000 : 0
      this.editAccount.block_end = this.editAccount.block_end ? Number(Date.parse(this.editAccount.block_end)) / 1000 : 0
      this.editAccount.balance = Number(this.editAccount.balance)
      this.editAccount.credit = Number(this.editAccount.credit)
      this.editAccount.block_type = Number(this.editAccount.block_type)
      this.editAccount.vat_rate = Number(this.editAccount.vat_rate)
      this.editAccount.sale_tax_rate = Number(this.editAccount.sale_tax_rate)
      axiosInstance.put(this.$store.getters.API_USERS_ACCOUNTS, this.editAccount).then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          this.$root.$emit('makeToasts')
          this.$emit('close', null)
          this.$emit('refreshTable', null)
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/users/accounts/detail/main.vue